import { connect } from 'react-redux'
import requestChangeCardParent from '../../../sagas/requestChangeCardParent'
import requestAddCardSequence from '../../../sagas/requestAddCardSequence'
import requestAddNewCardParent from 'routes/Board/sagas/requestAddNewCardParent'
import requestAddNewChildCard from 'routes/Board/sagas/requestAddNewChildCard'
import requestAddNewNextCard from 'routes/Board/sagas/requestAddNewNextCard'
import requestAddNewPrevCard from 'routes/Board/sagas/requestAddNewPrevCard'
import addCardRelationSelector from './addCardRelationSelector'
import AddCardRelation from './AddCardRelation'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  addCardRelationSelector,
  {
    requestChangeCardParent,
    requestAddCardSequence,
    requestAddNewCardParent,
    requestAddNewChildCard,
    requestAddNewNextCard,
    requestAddNewPrevCard,
  }
)(AddCardRelation))
